import { cx } from "@/utils";
import Tooltip from "@components/Tooltip";
import Typography from "@components/Typography";

import styles from "./Highlight.module.css";

interface HighlightProps extends React.HTMLAttributes<HTMLSpanElement> {
  label: string;
  icon?: IconComponent;
  className?: string;
  iconProps?: IconComponentProps;
  tooltip?: string;
}

// not sure about this component name
const Highlight = ({
  label,
  icon: Icon,
  iconProps = {},
  className,
  tooltip = undefined,
  ...props
}: HighlightProps) => (
  <span className={cx(styles.root, className)} {...props}>
    {Icon ? <Icon height="1rem" {...iconProps} /> : null}
    <Tooltip passThrough={!tooltip} content={tooltip} asChild={false}>
      <Typography variant="caption" className={styles.text}>
        {label}
      </Typography>
    </Tooltip>
  </span>
);

export default Highlight;
